/** @format */

/**
 * External dependencies
 */
import { get } from 'lodash';
import { select } from '@wordpress/data';

/**
 * Internal dependencies
 */
import { serializeQueryArgs } from '../utils';
import { ERROR } from '../constants';

/**
 * Returns all products.
 *
 * @param {Object} state Current state
 * @param {Object} query Products query parameters
 * @return {Array} Products
 */
function getProducts( state, query = {} ) {
	return get( state, [ 'products', serializeQueryArgs( query ), 'records' ], [] );
}

export default {
	getProducts,
	/**
	 * Returns true if a prodcuts API is pending.
	 *
	 * @param  {Object} state   Current state
	 * @return {Boolean}        True if the `getAvailability` request is pending, false otherwise
	 */
	isGetProductsRequesting( state, ...args ) {
		return select( 'core/data' ).isResolving( 'woocommerce-bookings-availability', 'getProducts', args );
	},

	/**
	 * Returns true if a get products request has returned an error.
	 *
	 * @param  {Object} state     Current state
 	 * @param  {Object} query     Products query parameters
	 */
	isGetProductsError( state, query ) {
		return ERROR === getProducts( state, query );
	},
};
